<template>
  <div>
    <div
    v-if="!disabled"
    class="d-flex justify-center">
      <icon-button
      @click="openChooseFileWindow"
      src="file-plus"
      :size="35"
      :disabled="!canAddMore"
      color="green"/>
      <input ref="chooseFile" type="file" class="d-none" multiple @input="add"/>
    </div>
    <div class="mt-4">
      <span
      v-show="attachmentsProp.length > 0"
      class="process-repair-tab-section-title"
      style="font-size: 15px;">
        {{$t('textFields.selectedAttachments')}}
      </span>
      <removable-attachment
      v-for="({name, size, base64, downloadLink, previewLink}, i) of attachmentsProp"
      :key="i"
      :name="name"
      :size-label="`[${getAttachmentSizeForPreview(size)}]`"
      :download-link="base64 || downloadLink"
      :preview-link="previewLink"
      :disabled="disabled"
      @remove="remove(i)"
      />
    </div>    
  </div>
</template>

<script>
import RemovableAttachment from '@/components/lists/items/RemovableAttachment'
import IconButton from '@/components/btns/IconButton'
import { getFileAsBase64, getSizeInApproximateUnit } from "@/utils/FileUtil"
export default {
  components: {
    IconButton,
    RemovableAttachment
  },
  props: {
    attachments: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: null
    },
    maxSize: {
      type: Number,
      default: null
    },
    unit: {
      type: String,
      default: "B"
    }
  },
  data: () => {
    return {
      selectableAttachment: null
    }
  },
  computed: {
    attachmentsProp: {
      get: function() {
        return this.$props.attachments
      },
      set: function(v) {
        this.$emit("update:attachments", v)
      }
    },
    canAddMore() {
      return this.max === null || this.max > this.attachments.length
    },
    getNumberByUnit() {
      switch(this.unit) {
        case "KB": return 1000
        case "MB": return 1000000
        default: return 1
      }
    }
  },
  methods: {
    openChooseFileWindow() {
      this.$refs.chooseFile.click()
    },
    async add({ target }) {
      const { files } = target

      if (files.length === 0) return

      const newFiles = []

      for(let i = 0; i < files.length; i++) {
        const f = files[i]
        
        if (this.maxSize && this.maxSize * this.getNumberByUnit <= f.size) {
          this.$snackbar.failed("snackbar.failed.repairPartAttachmentMaxSizeExceeded", {"max": this.maxSize})
          return
        }
        const newFile = {
          name: f.name,
          base64: await getFileAsBase64(f),
          size: f.size,
          type: f.type,
          previewLink: URL.createObjectURL(f)
        }
        this.attachmentsProp.push(newFile)
        newFiles.push(newFile)

        if (this.attachmentsProp.length === this.max) break
      }

      if (newFiles.length > 0) this.$emit("add", newFiles)
    },
    remove(i) {
      this.attachmentsProp.splice(i, 1)
      this.$emit("remove")
    },
    getAttachmentSizeForPreview(size) {
      return getSizeInApproximateUnit(size)
    }
  }
}
</script>

<style>

</style>

 <!-- 
  private String name;
  private String base64;
  private Long size;
  private String type; -->